
export function isoTimeToLocalString(timestamp, timeAggType, localTimeZone) {

    const d = new Date(timestamp);

    const options = {
        year: "numeric"
    }

    if (["m", "q", "d", "h"].includes(timeAggType)) {
        options.month = "short"
    }

    if (["d", "h"].includes(timeAggType)) {
        options.day = "numeric"
    }

    if (["h"].includes(timeAggType)) {
        options.hour = "numeric"
    }

    options.timeZone = localTimeZone;

    return d.toLocaleDateString(undefined, options)

}

export function transpose(matrix) {
    return matrix.reduce((prev, next) => next.map((item, i) =>
        (prev[i] || []).concat(next[i])
    ), []);
}